var _title, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowPointer = function SvgArrowPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 86,
    viewBox: "0 0 42 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Curve purple arrow")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 1C50 22.5 46.5 47.5 1.5 83.5M1.5 83.5L3.5 76.5M1.5 83.5L8 84.5",
    stroke: "url(#paint0_linear_491_1589)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_1589",
    x1: 25.5,
    y1: 1,
    x2: 34.517,
    y2: 56.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573837,
    stopColor: "#202261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#543C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6939A2"
  })))));
};
export { SvgArrowPointer as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA0MiA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiByb2xlPSJpbWciPgo8dGl0bGU+Q3VydmUgcHVycGxlIGFycm93PC90aXRsZT4KPHBhdGggZD0iTTI1LjUgMUM1MCAyMi41IDQ2LjUgNDcuNSAxLjUgODMuNU0xLjUgODMuNUwzLjUgNzYuNU0xLjUgODMuNUw4IDg0LjUiIHN0cm9rZT0idXJsKCNwYWludDBfbGluZWFyXzQ5MV8xNTg5KSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl80OTFfMTU4OSIgeDE9IjI1LjUiIHkxPSIxIiB4Mj0iMzQuNTE3IiB5Mj0iNTYuOTU3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMC41NzM4MzciIHN0b3AtY29sb3I9IiMyMDIyNjEiLz4KPHN0b3Agb2Zmc2V0PSIwLjgwMjA4MyIgc3RvcC1jb2xvcj0iIzU0M0M5NyIvPgo8c3RvcCBvZmZzZXQ9IjAuOTczOTU4IiBzdG9wLWNvbG9yPSIjNjkzOUEyIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";